import React from "react"
import { Grid, Heading, Stack } from "@chakra-ui/react"

import {
  LearnPage,
  LearnPageBadges,
  LearnPageTitle,
  LearnPageDescription,
  LearnPageAttributes,
  LearnPageImageRatio,
} from "@components/LearnPage"
import { ArticleColumnProps } from "."

const ArticleColumnLarge = ({ column, handleTrackingClick }: ArticleColumnProps) => (
  <Stack key={column.key} spacing={2.5} flexGrow={1}>
    <Heading textAlign={["center", "left"]} as="h2" size="h2">
      {column.title}
    </Heading>
    <Grid templateColumns={["none", "repeat(2, 1fr)"]} rowGap={3} columnGap={2}>
      {column?.articles?.map?.(article => (
        <LearnPage key={article.key} item={article} handleTrackingClick={handleTrackingClick}>
          <Stack spacing={2}>
            <LearnPageImageRatio aspectRatioProps={{ ratio: 427 / 318 }} />
            <LearnPageBadges />
            <LearnPageTitle />
            <LearnPageDescription />
            <LearnPageAttributes />
          </Stack>
        </LearnPage>
      ))}
    </Grid>
  </Stack>
)

export default React.memo(ArticleColumnLarge)
